import { Box } from "@mui/material";
import { DataTable } from "../../components/data-table";
import assetData from "../../tools/assets.json";
import { useState } from "react";

export const DataTableExample = () => {
  const [selection, setSelection] = useState<string[]>([]);

  const handleSelect = (assetId: (string | number) | (string | number)[]) => {
    if (typeof assetId === "string" || typeof assetId === "number") {
      setSelection((currentSelection) =>
        currentSelection.includes(assetId as string)
          ? (currentSelection.filter((id) => id !== assetId) as string[])
          : ([...currentSelection, assetId] as string[])
      );
      // handle array
    } else if (Array.isArray(assetId)) {
      const isRemoveAll = assetId.length === selection.length;
      setSelection(isRemoveAll ? [] : (assetId as string[]));
    }
  };
  return (
    <Box>
      <DataTable
        data={assetData}
        getKey={(data) => data.id as string}
        onSelect={handleSelect}
        onDeselect={handleSelect}
        selectedRows={selection}
      />
    </Box>
  );
};
